module.exports = __webpack_public_path__ + "img/small_whale21.6c118a01.jpg";